<div class="modal-header">
    <h4 *ngIf="!isDetailMode" class="modal-title pull-left">
        {{itemToSave?.id ? "Modification "+title : "Enregistrement "+title}}
    </h4>
    <h4 *ngIf="isDetailMode" class="modal-title pull-left">
        {{"Détail "+title}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busySave,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">



            <form class="m-1">

                <mat-tab-group mat-align-tabs="start" #tabGroup (selectedIndexChange)="selectedChangeValue($event)"
                    [(selectedIndex)]="indiceTab">
                    <mat-tab label="Informations">
                        <div *ngIf="indiceTab == 0" style="overflow-x: hidden">
                            <div class="container-fluid" style="min-height: 380px;">
                                <div class="row">
                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Code:
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input class="form-control custom-input" placeholder="Code" autocomplete="off"
                                            [(ngModel)]="itemToSave.code" name="code" autocomplete="off" type="text" />
                                    </div> -->
                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Codification:
                                        </label>
                                        <input class="form-control custom-input" placeholder="Codification"
                                            autocomplete="off" [(ngModel)]="itemToSave.codification" name="codification"
                                            autocomplete="off" type="text" />
                                    </div> -->
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Libellé :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Libellé" autocomplete="off" [(ngModel)]="itemToSave.libelle"
                                            name="libelle" autocomplete="off" type="text" />
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Type :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <ng-select [disabled]="isDetailMode" [(ngModel)]="itemToSave.type_garant_id"
                                            placeholder="Choisissez " name="type_garant_id" id="type_garant_id"
                                            [multiple]="false" [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsTypeGarant" [value]="item.id">{{
                                                item?.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Email :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Email" autocomplete="off" [(ngModel)]="itemToSave.email"
                                            name="email" autocomplete="off" type="text" />
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Fax :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Fax" autocomplete="off" [(ngModel)]="itemToSave.fax" name="fax"
                                            autocomplete="off" type="text" mask="00-00-00-00-00" />
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Adresse :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Adresse" autocomplete="off" [(ngModel)]="itemToSave.adresse"
                                            name="adresse" autocomplete="off" type="text" />
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Boite postale :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Boite postale" autocomplete="off"
                                            [(ngModel)]="itemToSave.boite_postale" name="boite_postale"
                                            autocomplete="off" type="text" />
                                    </div>

                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Numéro compte bancaire :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Numéro compte bancaire" autocomplete="off"
                                            [(ngModel)]="itemToSave.numero_compte_bancaire"
                                            name="numero_compte_bancaire" autocomplete="off" type="text" />
                                    </div>

                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Numéro compte tp :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Numéro compte tp" autocomplete="off"
                                            [(ngModel)]="itemToSave.numero_compte_tiers_payant"
                                            name="numero_compte_tiers_payant" autocomplete="off" type="text" />
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Numéro compte rd :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Numéro compte rd" autocomplete="off"
                                            [(ngModel)]="itemToSave.numero_compte_rd" name="numero_compte_rd"
                                            autocomplete="off" type="text" />
                                    </div>

                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Responsable :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Responsable" autocomplete="off"
                                            [(ngModel)]="itemToSave.responsable" name="responsable" autocomplete="off"
                                            type="text">
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Email responsable :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Email responsable" autocomplete="off"
                                            [(ngModel)]="itemToSave.email_responsable" name="email_responsable"
                                            autocomplete="off" type="text">
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Fax responsable :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Fax responsable" autocomplete="off"
                                            [(ngModel)]="itemToSave.fax_responsable" name="fax_responsable"
                                            autocomplete="off" type="text" mask="00-00-00-00-00">
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Boite postale responsable :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Boite postale responsable" autocomplete="off"
                                            [(ngModel)]="itemToSave.boite_postale_responsable"
                                            name="boite_postale_responsable" autocomplete="off" type="text">
                                    </div>

                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Taux commission sinistre :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="(itemToSave.forfait_commission_sinistre >0) || isDetailMode"
                                            mask="separator" class="form-control custom-input"
                                            placeholder="Taux commission sinistre" autocomplete="off"
                                            [(ngModel)]="itemToSave.taux_commission_sinistre"
                                            name="taux_commission_sinistre" autocomplete="off" type="text"
                                            mask="separator" />
                                    </div> -->
                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Forfait commission sinistre :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="(itemToSave.taux_commission_sinistre>0) || isDetailMode"
                                            mask="separator" class="form-control custom-input"
                                            placeholder="Forfait commission sinsitre" autocomplete="off"
                                            [(ngModel)]="itemToSave.forfait_commission_sinistre"
                                            name="forfait_commission_sinistre" autocomplete="off" type="text"
                                            mask="separator" />
                                    </div> -->
                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Taux commission prime :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="(itemToSave.forfait_commission_prime>0) || isDetailMode"
                                            mask="separator" class="form-control custom-input"
                                            placeholder="Taux commission prime" autocomplete="off"
                                            [(ngModel)]="itemToSave.taux_commission_prime" name="taux_commission_prime"
                                            autocomplete="off" type="text" mask="separator" />
                                    </div> -->
                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                                    <label>Taux tva :
                                        <span class="required_champs">*</span>
                                    </label>
                                    <input [disabled]="itemToSave.tva>0" mask="separator" class="form-control custom-input" placeholder="Taux commission prime" autocomplete="off"
                                        [(ngModel)]="itemToSave.taux_tva" name="taux_tva" autocomplete="off" type="text" mask="separator" />
                                </div> -->

                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Forfait commission prime :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="(itemToSave.taux_commission_prime>0) || isDetailMode"
                                            mask="separator" class="form-control custom-input"
                                            placeholder="Forfait commission prime" autocomplete="off"
                                            [(ngModel)]="itemToSave.forfait_commission_prime"
                                            name="forfait_commission_prime" autocomplete="off" type="text"
                                            mask="separator" />
                                    </div> -->

                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label (click)="openModalPrestataireReseau()"
                                            [ngClass]="{'isSelectedItem':itemToSave.reseau_de_soin_id}">Réseau de soin :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <ng-select [(ngModel)]="itemToSave.reseau_de_soin_id" placeholder="Choisissez "
                                            name="reseau_de_soin_id" id="reseau_de_soin_id" [multiple]="false"
                                            [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsReseauDeSoin" [value]="item.id">{{
                                                item.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Tva (%) :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" mask="separator"
                                            class="form-control custom-input" placeholder="Taux tva" autocomplete="off"
                                            [(ngModel)]="itemToSave.tva" name="tva" autocomplete="off" type="text"
                                            mask="separator" />
                                    </div>

                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Type remboursement :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <ng-select (change)="onSelectTypeRemboursement()" [disabled]="isDetailMode"
                                            [(ngModel)]="itemToSave.type_remboursement_id" placeholder="Choisissez "
                                            name="type_remboursement_id" id="type_remboursement_id" [multiple]="false"
                                            [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsTypeRemboursement" [value]="item.id">{{
                                                item?.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                    <!-- 
                                    <div *ngIf="is_tpg"
                                        class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Taux tpg (%) :
                                            <span class="required_champs">*</span>
                                        </label>

                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Taux tpg" autocomplete="off" [(ngModel)]="itemToSave.taux_tpg"
                                            name="taux_tpg" autocomplete="off" type="text" mask="separator" />

                                    </div>
                                    <div *ngIf="is_tpg"
                                        class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Majoration tpg (%) :
                                            <span class="required_champs">*</span>
                                        </label>

                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Majoration tpg" autocomplete="off"
                                            [(ngModel)]="itemToSave.majoration_tpg" name="majoration_tpg"
                                            autocomplete="off" type="text" mask="separator" />

                                    </div>
                                    <div *ngIf="is_tpg"
                                        class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Plafond tpg (%) :
                                            <span class="required_champs">*</span>
                                        </label>

                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Plafond tpg" autocomplete="off"
                                            [(ngModel)]="itemToSave.plafond_tpg" name="plafond_tpg" autocomplete="off"
                                            type="text" mask="separator" />

                                    </div> -->

                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Mode règlement :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <ng-select [disabled]="isDetailMode" [(ngModel)]="itemToSave.mode_reglement_id"
                                            placeholder="Choisissez " name="mode_reglement_id" id="mode_reglement_id"
                                            [multiple]="false" [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsModeReglement" [value]="item.id">{{
                                                item.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>


                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Seuil alerte consommation (%) :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Seuil alerte conso" autocomplete="off"
                                            [(ngModel)]="itemToSave.seuil_alerte_conso" name="seuil_alerte_conso"
                                            autocomplete="off" type="text" mask="separator" />
                                    </div> -->



                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Seuil suspension tiers payant (%) :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Seuil suspension tp" autocomplete="off"
                                            [(ngModel)]="itemToSave.seuil_suspension_tiers_payant"
                                            name="seuil_suspension_tiers_payant" autocomplete="off" type="text"
                                            mask="separator" />
                                    </div> -->
                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Taux ristourne (%) :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Taux ristourne" autocomplete="off"
                                            [(ngModel)]="itemToSave.taux_ristourne" name="taux_ristourne"
                                            autocomplete="off" type="text" mask="separator" />
                                    </div> -->


                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>A qui rembourser? :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <ng-select [disabled]="isDetailMode"
                                            [(ngModel)]="itemToSave.assure_remboursement" placeholder="Choisissez "
                                            name="assure_remboursement" id="assure_remboursement" [multiple]="false"
                                            [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsRemboursement" [value]="item.code">{{
                                                item.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div> -->
                                    <!-- 
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Mode tarification :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <ng-select [disabled]="isDetailMode"
                                            [(ngModel)]="itemToSave.mode_tarification_id" placeholder="Choisissez "
                                            name="mode_tarification_id" id="mode_tarification_id" [multiple]="false"
                                            [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsModeTarification" [value]="item.id">{{
                                                item.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div> -->

                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Mode reconduction :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <ng-select [disabled]="isDetailMode"
                                            [(ngModel)]="itemToSave.mode_reconduction_id" placeholder="Choisissez "
                                            name="mode_reconduction_id" id="mode_reconduction_id" [multiple]="false"
                                            [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsModeReconduction" [value]="item.id">{{
                                                item.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div> -->
                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Mode fractionnement :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <ng-select [disabled]="isDetailMode"
                                            [(ngModel)]="itemToSave.mode_fractionnement_id" placeholder="Choisissez "
                                            name="mode_fractionnement_id" id="mode_fractionnement_id" [multiple]="false"
                                            [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsModeFractionnement" [value]="item.id">{{
                                                item.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div> -->
                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Tarif :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <ng-select [disabled]="isDetailMode" [(ngModel)]="itemToSave.tarif_id"
                                            placeholder="Choisissez " name="tarif_id" id="tarif_id" [multiple]="false"
                                            [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsTarif" [value]="item.id">{{ item.libelle
                                                }}
                                            </ng-option>
                                        </ng-select>
                                    </div> -->
                                    <!-- 
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label (click)="openModalPrestataireReseau()"
                                            [ngClass]="{'isSelectedItem':itemToSave.reseau_de_soin_id}">Réseau de soin :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <ng-select [disabled]="isDetailMode" [(ngModel)]="itemToSave.reseau_de_soin_id"
                                            placeholder="Choisissez " name="reseau_de_soin_id" id="reseau_de_soin_id"
                                            [multiple]="false" [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsReseauDeSoin" [value]="item.id">{{
                                                item.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div> -->



                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Statut :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <ng-select [disabled]="isDetailMode" [(ngModel)]="itemToSave.statut_garant_id"
                                            placeholder="Choisissez " name="statut_garant_id" id="statut_garant_id"
                                            [multiple]="false" [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsStatutGarant" [value]="item.id">{{
                                                item.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div> -->
                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Mode gestion avenant :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <ng-select [clearable]="false" [disabled]="isDetailMode"
                                            [(ngModel)]="itemToSave.mode_gest_avenant" placeholder="Choisissez "
                                            name="mode_gest_avenant" id="mode_gest_avenant" [multiple]="false"
                                            [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsListeModeGestAvenant"
                                                [value]="item.value">{{ item.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div> -->
                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Périodicité avenant :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <ng-select [clearable]="false" [disabled]="isDetailMode"
                                            [(ngModel)]="itemToSave.periodicite_avenant" placeholder="Choisissez "
                                            name="periodicite_avenant" id="periodicite_avenant" [multiple]="false"
                                            [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsPeriodiciteAvenant"
                                                [value]="item.value">{{ item.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div> -->
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Mode gestion accéssoires :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <ng-select [clearable]="false" [disabled]="isDetailMode"
                                            [(ngModel)]="itemToSave.mode_gest_accessoire" placeholder="Choisissez "
                                            name="mode_gest_accessoire" id="mode_gest_accessoire" [multiple]="false"
                                            [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsListeModeGestAccessoire"
                                                [value]="item.value">{{ item.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                    <div *ngIf="itemToSave.mode_gest_accessoire == 'PARTAGE'"
                                        class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Taux gestionnaire:
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Taux gestionnaire" autocomplete="off"
                                            [(ngModel)]="itemToSave.taux_partage_accessoire"
                                            name="taux_partage_accessoire" autocomplete="off" type="text"
                                            mask="separator" />
                                    </div>
                                    <div *ngIf="itemToSave.mode_gest_accessoire == 'PARTAGE'"
                                        class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Taux garant :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Taux garant" autocomplete="off"
                                            [(ngModel)]="itemToSave.taux_partage_accessoire_garant"
                                            name="taux_partage_accessoire_garant" autocomplete="off" type="text"
                                            mask="separator" />
                                    </div>
                                    <!-- <div *ngIf="itemToSave.mode_gest_accessoire == 'PARTAGE'"
                                        class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Taux courtier  :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Taux garant" autocomplete="off"
                                            [(ngModel)]="itemToSave.taux_partage_accessoire_courtier"
                                            name="taux_partage_accessoire_courtier" autocomplete="off" type="text"
                                            mask="separator" />
                                    </div> -->
                                    <div *ngIf="itemToSave.mode_gest_accessoire == 'PARTAGE'"
                                        class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Taux intermédiaire :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Taux garant" autocomplete="off"
                                            [(ngModel)]="itemToSave.taux_partage_accessoire_intermediaire"
                                            name="taux_partage_accessoire_intermediaire" autocomplete="off" type="text"
                                            mask="separator" />
                                    </div>
                                    <!-- <div *ngIf="itemToSave.mode_gest_accessoire == 'PARTAGE'"
                                        class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                                        <label>Taux apporteur  :
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Taux garant" autocomplete="off"
                                            [(ngModel)]="itemToSave.taux_partage_accessoire_apporteur"
                                            name="taux_partage_accessoire_apporteur" autocomplete="off" type="text"
                                            mask="separator" />
                                    </div> -->

                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Image :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" (change)="uploadFile($event)"
                                            class="form-control custom-input" autocomplete="off" name="image"
                                            autocomplete="off" type="file" />
                                    </div>

                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <input [disabled]="isDetailMode" [(ngModel)]="itemToSave.is_prorata_prime"
                                            id="is_prorata_prime" name="is_prorata_prime" autocomplete="off"
                                            type="checkbox" />
                                        <label for="is_prorata_prime">Prorata prime?
                                        </label>

                                        <ng-select *ngIf="itemToSave.is_prorata_prime"
                                            [(ngModel)]="itemToSave.mode_prorata_id"
                                            placeholder="Choisissez mode prorata " name="mode_prorata_id"
                                            id="statut_garant_id" [multiple]="false" [closeOnSelect]="true">
                                            <ng-option *ngFor="let item of itemsModeProrata" [value]="item.id">{{
                                                item.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>

                                    <!-- <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <input [disabled]="isDetailMode"
                                            [(ngModel)]="itemToSave.is_attente_prealable_acte_visible"
                                            id="is_attente_prealable_acte_visible"
                                            name="is_attente_prealable_acte_visible" autocomplete="off"
                                            type="checkbox" />
                                        <label for="is_attente_prealable_acte_visible">Acte entente préalable visible?
                                        </label>


                                    </div> -->
                                    <!-- <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <input [disabled]="isDetailMode"
                                            [(ngModel)]="itemToSave.is_non_garantie_acte_visible"
                                            id="is_non_garantie_acte_visible" name="is_non_garantie_acte_visible"
                                            autocomplete="off" type="checkbox" />
                                        <label for="is_non_garantie_acte_visible">Actes non garantis visibles?
                                        </label>


                                    </div> -->
                                    <!-- <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <input [disabled]="isDetailMode"
                                            [(ngModel)]="itemToSave.is_attente_prealable_medoc_visible"
                                            id="is_attente_prealable_medoc_visible"
                                            name="is_attente_prealable_medoc_visible" autocomplete="off"
                                            type="checkbox" />
                                        <label for="is_attente_prealable_medoc_visible">Médoc entente préalable visible?
                                        </label>


                                    </div> -->
                                    <!-- <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <input [disabled]="isDetailMode"
                                            [(ngModel)]="itemToSave.is_non_garantie_medoc_visible"
                                            id="is_non_garantie_medoc_visible" name="is_non_garantie_medoc_visible"
                                            autocomplete="off" type="checkbox" />
                                        <label for="is_non_garantie_medoc_visible">Médoc non garantie visible?
                                        </label>


                                    </div> -->


                                </div>
                            </div>

                        </div>
                    </mat-tab>
                    <mat-tab label="Données de facturation">
                        <div *ngIf="indiceTab == 1" style="overflow-x: hidden; padding: 12px 4px;">
                            <div class="row">

                                <!-- ===== Colonne gauche : Caution + Sinistre + Déficit ===== -->
                                <div class="col-md-6">

                                    <!-- Facture caution garantie -->
                                    <div class="fact-section">
                                        <div class="fact-section-header fact-caution">
                                            <i class="fa fa-shield-alt mr-2"></i> Facture caution garantie
                                        </div>
                                        <div class="fact-section-body">
                                            <div class="row">
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Fraction caution démarrage
                                                        (Nbr/12)</label>
                                                    <input
                                                        matTooltip="Fraction Caution = Nb mois / 12. Une fraction (très souvent 2/12) des sinistres. Quand il s'agit d'un démarrage, les sinistres sont estimés (provision de sinistre) et on applique 2/12 pour obtenir la caution de démarrage."
                                                        class="form-control form-control-sm"
                                                        placeholder="Fraction caution" autocomplete="off"
                                                        [(ngModel)]="itemToSave.fraction_caution"
                                                        name="fraction_caution" type="text" />
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Source fond caution permanente</label>
                                                    <ng-select [appendTo]="'body'"
                                                        matTooltip="Le montant que le garant dépose comme garantie au gestionnaire. Ce montant peut provenir n/12ième des sinistres provisionnés ou d'un forfait."
                                                        [(ngModel)]="itemToSave.source_fond_caution_permanente"
                                                        placeholder="Choisissez" name="source_fond_caution_permanente"
                                                        [multiple]="false" [closeOnSelect]="true"
                                                        (change)="onChangeSourceFondCaution()">
                                                        <ng-option *ngFor="let item of itemsSourceFondCaution"
                                                            [value]="item.code">{{ item?.libelle }}</ng-option>
                                                    </ng-select>
                                                </div>
                                                <div class="col-md-6 mb-2"
                                                    *ngIf="itemToSave.source_fond_caution_permanente !== 'FORFAIT'">
                                                    <label class="fact-label">Assiette fond caution garantie</label>
                                                    <ng-select [appendTo]="'body'"
                                                        matTooltip="Que la source de caution soit forfait ou provision de sinistre, il faut indiquer l'assiette : par garant (nombre=1), par famille (nombre de familles) ou par bénéficiaire (nombre d'individus)."
                                                        [disabled]="isDetailMode"
                                                        [(ngModel)]="itemToSave.assiete_fond_caution_permanente"
                                                        placeholder="Choisissez" name="assiete_fond_caution_permanente"
                                                        [multiple]="false" [closeOnSelect]="true"
                                                        (change)="onChangeAssieteCaution()">
                                                        <ng-option *ngFor="let item of assietteDeFond"
                                                            [value]="item.code">{{ item?.libelle }}</ng-option>
                                                    </ng-select>
                                                </div>
                                                <div class="col-md-6 mb-2"
                                                    *ngIf="itemToSave.source_fond_caution_permanente === 'FORFAIT'">
                                                    <label class="fact-label">Forfait caution permanente</label>
                                                    <input
                                                        matTooltip="Si la source de fond de caution permanente est un forfait, on renseigne ce montant (HT)."
                                                        [disabled]="isDetailMode" class="form-control form-control-sm"
                                                        placeholder="Forfait caution permanente" autocomplete="off"
                                                        [(ngModel)]="itemToSave.forfait_caution_permanente"
                                                        name="forfait_caution_permanente" type="text"
                                                        mask="separator" />
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Seuil complément caution (%)</label>
                                                    <input
                                                        matTooltip="Soit n le seuil, k la fraction de caution, s le cumul des sinistres de l'année écoulée et c la caution actuelle. C2 = k/12 × s. Si Δc (C2-C) > n×C/100, une facture complémentaire de Δc est adressée au garant (nouvelle caution – ancienne caution)."
                                                        class="form-control form-control-sm"
                                                        placeholder="Seuil complément caution" autocomplete="off"
                                                        [(ngModel)]="itemToSave.seuil_complement_caution"
                                                        name="seuil_complement_caution" type="text" />
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Périodicité caution</label>
                                                    <ng-select [appendTo]="'body'"
                                                        matTooltip="Fréquence d'émission de la facture caution au garant (mensuelle, trimestrielle, semestrielle, annuelle)."
                                                        [(ngModel)]="itemToSave.periodicite_caution"
                                                        placeholder="Choisissez" name="periodicite_caution"
                                                        [multiple]="false" [closeOnSelect]="true">
                                                        <ng-option *ngFor="let item of periodicite"
                                                            [value]="item.code">{{ item?.libelle }}</ng-option>
                                                    </ng-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Facture sinistre -->
                                    <div class="fact-section">
                                        <div class="fact-section-header fact-sinistre">
                                            <i class="fa fa-file-medical mr-2"></i> Facture sinistre
                                            <small class="ml-2 font-weight-normal"
                                                style="font-size:11px; opacity:0.85;">(remboursement des dépenses des
                                                assurés)</small>
                                        </div>
                                        <div class="fact-section-body">
                                            <div class="row">
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Source fond sinistre</label>
                                                    <ng-select [appendTo]="'body'"
                                                        matTooltip="Facture type 2 — Remboursement des dépenses des assurés (consultations, médicaments, hospitalisations...). Sinistres réels : pour les gros garants, le gestionnaire facture au fur et à mesure. Provision sinistres : pour les petits garants (mutuelles, auto-financement), le gestionnaire encaisse une avance par précaution."
                                                        [disabled]="isDetailMode"
                                                        [(ngModel)]="itemToSave.source_fond_sinistre"
                                                        placeholder="Choisissez" name="source_fond_sinistre"
                                                        [multiple]="false" [closeOnSelect]="true"
                                                        (change)="onChangeSourceFondSinistre()">
                                                        <ng-option *ngFor="let item of itemsSourceFondSinistre"
                                                            [value]="item.code">{{ item?.libelle }}</ng-option>
                                                    </ng-select>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">
                                                        Assiète fond sinistre
                                                        <span class="fact-badge-forced"
                                                            *ngIf="itemToSave.source_fond_sinistre === 'SINISTRE-REEL'">Forcé
                                                            : Aucune</span>
                                                    </label>
                                                    <ng-select [appendTo]="'body'"
                                                        matTooltip="La base de calcul de la source de fond : Par garant (nombre=1), Par famille (nombre de familles), Par bénéficiaire (nombre d'individus). Forcé à Aucune si source = Sinistres réels."
                                                        [disabled]="isDetailMode || itemToSave.source_fond_sinistre === 'SINISTRE-REEL'"
                                                        [(ngModel)]="itemToSave.assiete_fond_sinistre"
                                                        placeholder="Choisissez" name="assiete_fond_sinistre"
                                                        [multiple]="false" [closeOnSelect]="true"
                                                        (change)="onChangeAssieteSinistre()">
                                                        <ng-option *ngFor="let item of assietteDeFond"
                                                            [value]="item.code">{{ item?.libelle }}</ng-option>
                                                    </ng-select>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Périodicité fond sinistre</label>
                                                    <ng-select [appendTo]="'body'"
                                                        matTooltip="C'est la fréquence d'établissement de factures au garant (concerne uniquement les factures de type 2 : sinistres)."
                                                        [(ngModel)]="itemToSave.periodicite_fond_sinistre"
                                                        placeholder="Choisissez" name="periodicite_fond_sinistre"
                                                        [multiple]="false" [closeOnSelect]="true"
                                                        (change)="onChangePeriodiciteFondSinistre()">
                                                        <ng-option *ngFor="let item of periodicite"
                                                            [value]="item.code">{{ item?.libelle }}</ng-option>
                                                    </ng-select>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Taux commission provision sinistre
                                                        (%)</label>
                                                    <input
                                                        matTooltip="Si l'on choisit de calculer les honoraires sur les sinistres (provisionnés ou réalisés), on renseigne le taux à appliquer aux sinistres."
                                                        [disabled]="isDetailMode" class="form-control form-control-sm"
                                                        placeholder="Taux commission provision sinistre"
                                                        autocomplete="off"
                                                        [(ngModel)]="itemToSave.taux_commission_prov_sinistre"
                                                        name="taux_commission_prov_sinistre" type="text"
                                                        mask="separator" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Facture déficit -->
                                    <div class="fact-section">
                                        <div class="fact-section-header fact-deficit">
                                            <i class="fa fa-balance-scale mr-2"></i> Facture déficit
                                            <small class="ml-2 font-weight-normal"
                                                style="font-size:11px; opacity:0.85;">(provision épuisée ou
                                                insuffisante)</small>
                                        </div>
                                        <div class="fact-section-body">
                                            <div class="row">
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Périodicité facturation déficit</label>
                                                    <ng-select [appendTo]="'body'"
                                                        matTooltip="Facture type 3 — Utilisée uniquement avec les petits garants (provision de sinistres). Quand la provision est épuisée ou insuffisante, le gestionnaire adresse une facture de déficit pour réclamer la différence (sinistres réels – provision encaissée). Cette périodicité définit la fréquence du calcul."
                                                        [(ngModel)]="itemToSave.periodicite_deficit"
                                                        placeholder="Choisissez" name="periodicite_deficit"
                                                        [multiple]="false" [closeOnSelect]="true"
                                                        (change)="onChangePeriodiciteDeficit()">
                                                        <ng-option *ngFor="let item of periodicite"
                                                            [value]="item.code">{{ item?.libelle }}</ng-option>
                                                    </ng-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <!-- ===== Colonne droite : Honoraire + Estimations ===== -->
                                <div class="col-md-6">

                                    <!-- Facture honoraire -->
                                    <div class="fact-section">
                                        <div class="fact-section-header fact-honoraire">
                                            <i class="fa fa-hand-holding-usd mr-2"></i> Facture honoraire
                                            <small class="ml-2 font-weight-normal"
                                                style="font-size:11px; opacity:0.85;">(rémunération du
                                                gestionnaire)</small>
                                        </div>
                                        <div class="fact-section-body">
                                            <div class="row">
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Source fond honoraire</label>
                                                    <ng-select [appendTo]="'body'"
                                                        matTooltip="Facture type 4 — La rémunération du gestionnaire : Prime (commission sur primes d'assurance) | Provisions sinistres (taux sur sinistres provisionnés, selon assiette) | Forfait (montant fixe convenu, sans assiette) | Sinistres réels (taux appliqué au sinistre réel)."
                                                        [disabled]="isDetailMode"
                                                        [(ngModel)]="itemToSave.source_fond_honoraire"
                                                        placeholder="Choisissez" name="source_fond_honoraire"
                                                        [multiple]="false" [closeOnSelect]="true"
                                                        (change)="onChangeSourceFondHonoraire()">
                                                        <ng-option *ngFor="let item of itemsSourceFondHonoraire"
                                                            [value]="item.code">{{ item?.libelle }}</ng-option>
                                                    </ng-select>
                                                </div>
                                                <div class="col-md-6 mb-2"
                                                    *ngIf="itemToSave.source_fond_honoraire === 'FORFAIT'">
                                                    <label class="fact-label">Forfait fond honoraire (HT) <span
                                                            class="required_champs">*</span></label>
                                                    <input
                                                        matTooltip="Facture type 4 — Si source = Forfait, préciser ici le montant du forfait (HT) servant de base au calcul des honoraires."
                                                        [disabled]="isDetailMode" class="form-control form-control-sm"
                                                        placeholder="Forfait fond honoraire" autocomplete="off"
                                                        [(ngModel)]="itemToSave.forfait_fond_honoraire"
                                                        name="forfait_fond_honoraire" type="text" mask="separator" />
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">
                                                        Assiète fond honoraire
                                                        <span class="fact-badge-forced"
                                                            *ngIf="itemToSave.source_fond_honoraire === 'SINISTRE-REEL' || itemToSave.source_fond_honoraire === 'FORFAIT'">Forcé
                                                            : Aucune</span>
                                                    </label>
                                                    <ng-select [appendTo]="'body'"
                                                        matTooltip="Facture type 4 — Si source = Provision sinistres, préciser l'assiette : par garant, par famille ou par bénéficiaire. Si source = Forfait, l'assiette est Aucune car le forfait est un montant convenu indépendamment de toute assiette. Si source = Sinistres réels, l'assiette est également Aucune."
                                                        [disabled]="isDetailMode || itemToSave.source_fond_honoraire === 'SINISTRE-REEL' || itemToSave.source_fond_honoraire === 'FORFAIT'"
                                                        [(ngModel)]="itemToSave.assiete_fond_honoraire"
                                                        placeholder="Choisissez" name="assiete_fond_honoraire"
                                                        [multiple]="false" [closeOnSelect]="true"
                                                        (change)="onChangeAssieteHonoraire()">
                                                        <ng-option *ngFor="let item of assietteDeFond"
                                                            [value]="item.code">{{ item?.libelle }}</ng-option>
                                                    </ng-select>
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Périodicité fond honoraire</label>
                                                    <ng-select [appendTo]="'body'"
                                                        matTooltip="C'est la fréquence d'établissement des factures d'honoraires au garant (facture type 4)."
                                                        [(ngModel)]="itemToSave.periodicite_fond_honoraire"
                                                        placeholder="Choisissez" name="periodicite_fond_honoraire"
                                                        [multiple]="false" [closeOnSelect]="true"
                                                        (change)="onChangePeriodiciteFondHonoraire()">
                                                        <ng-option *ngFor="let item of periodicite"
                                                            [value]="item.code">{{ item?.libelle }}</ng-option>
                                                    </ng-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Taux -->
                                    <div class="fact-section">
                                        <div class="fact-section-header fact-taux">
                                            <i class="fa fa-percent mr-2"></i> Taux
                                        </div>
                                        <div class="fact-section-body">
                                            <div class="row">
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Taux TVA (%)</label>
                                                    <input
                                                        matTooltip="Taux de TVA applicable sur les factures d'honoraires."
                                                        [disabled]="isDetailMode" class="form-control form-control-sm"
                                                        placeholder="Taux tva" autocomplete="off"
                                                        [(ngModel)]="itemToSave.taux_tva" name="taux_tva" type="text"
                                                        mask="separator" />
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Taux commission primes (%)</label>
                                                    <input
                                                        matTooltip="Si l'on choisit de calculer les honoraires par prime, on renseigne ici le taux à appliquer à la prime."
                                                        [disabled]="isDetailMode" class="form-control form-control-sm"
                                                        placeholder="Taux commission prime" autocomplete="off"
                                                        [(ngModel)]="itemToSave.taux_commission_prime"
                                                        name="taux_commission_prime" type="text" mask="separator" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Estimations -->
                                    <div class="fact-section">
                                        <div class="fact-section-header fact-estimation">
                                            <i class="fa fa-calculator mr-2"></i> Provision sinistre — Données de calcul
                                            <small class="ml-2 font-weight-normal"
                                                style="font-size:11px; opacity:0.85;">(petits garants : mutuelles,
                                                auto-financement)</small>
                                        </div>
                                        <div class="fact-section-body">
                                            <div class="row">
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Nombre de familles estimé</label>
                                                    <input
                                                        matTooltip="Nombre total de familles toutes polices confondues du garant."
                                                        [disabled]="isDetailMode" class="form-control form-control-sm"
                                                        placeholder="Estimation nombre famille" autocomplete="off"
                                                        [(ngModel)]="itemToSave.nombre_famille_estime"
                                                        name="nombre_famille_estime" type="text" mask="separator" />
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Prime estimée par famille</label>
                                                    <input
                                                        matTooltip="La prime approximative par famille, utilisée pour les calculs prévisionnels."
                                                        [disabled]="isDetailMode" class="form-control form-control-sm"
                                                        placeholder="Estimation prime par famille" autocomplete="off"
                                                        [(ngModel)]="itemToSave.prime_par_famille_estime"
                                                        name="prime_par_famille_estime" type="text" mask="separator" />
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Nombre de bénéficiaires estimé</label>
                                                    <input
                                                        matTooltip="Nombre total de bénéficiaires toutes polices confondues du garant."
                                                        [disabled]="isDetailMode" class="form-control form-control-sm"
                                                        placeholder="Estimation nombre bénéficiaires" autocomplete="off"
                                                        [(ngModel)]="itemToSave.nombre_beneficiaires_estime"
                                                        name="nombre_beneficiaires_estime" type="text"
                                                        mask="separator" />
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Prime estimée par bénéficiaire</label>
                                                    <input
                                                        matTooltip="La prime approximative par bénéficiaire, utilisée pour les calculs prévisionnels."
                                                        [disabled]="isDetailMode" class="form-control form-control-sm"
                                                        placeholder="Estimation prime par bénéficiaire"
                                                        autocomplete="off"
                                                        [(ngModel)]="itemToSave.prime_par_beneficiaire_estime"
                                                        name="prime_par_beneficiaire_estime" type="text"
                                                        mask="separator" />
                                                </div>
                                                <div class="col-md-6 mb-2">
                                                    <label class="fact-label">Montant provision garant</label>
                                                    <input
                                                        matTooltip="La valeur de l'assiette est renseignée dans ce champ (montant de la provision du garant, HT)."
                                                        [disabled]="isDetailMode" class="form-control form-control-sm"
                                                        placeholder="Montant provision garant" autocomplete="off"
                                                        [(ngModel)]="itemToSave.montant_provision_garant"
                                                        name="montant_provision_garant" type="text" mask="separator" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </mat-tab>

                </mat-tab-group>


            </form>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <button *ngIf="!isDetailMode" type="button" (click)="confirmSaveItem(itemToSave)"
            class="btn btn-md custom_btn_primary pull-right" [class.auth-spinner]="loading" [disabled]="loading">
            Sauvegarder
        </button>

        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>